/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AutoTestMaxConcurrentBatchRunsSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('AUTO_TEST_MAX_CONCURRENT_BATCH_RUNS')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecNumber)],
]);
export class AutoTestMaxConcurrentBatchRunsSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AutoTestMaxConcurrentBatchRunsSettingParser.decode(input).map(res => new AutoTestMaxConcurrentBatchRunsSetting(res));
    }
    static unsafeDecode(input) {
        return AutoTestMaxConcurrentBatchRunsSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoTestMaxConcurrentBatchRunsSettingParser.encode(data);
    }
    static schema() {
        return AutoTestMaxConcurrentBatchRunsSettingParser.schema();
    }
}
